import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import rootReducers from "./RootReducer";
import { composeWithDevTools } from "@redux-devtools/extension";
import rootSaga from "../saga/RootSaga";

const configureStore = () => {
  const sagaMidlleware = createSagaMiddleware();

  return {
    ...createStore(
      rootReducers,
      composeWithDevTools(applyMiddleware(sagaMidlleware))
    ),
    runSaga: sagaMidlleware.run(rootSaga),
  };
};

export default configureStore;
